import { IsPanelbarDetails, IsPanelbarDetailsField } from "../../../core/components/isPanelbarDetails.js";
import { Button } from "../../../core/components/button.js";
import { GeomapUtil } from "../../geomapUtil.js";
import { DirectionsCommonProps } from "../../directions/directions.js";
import { PerimeterSearchContextMenu, PerimeterSearchContextMenuTranslations } from "./perimeterSearchContextMenu.js";
import React from "react";
export class Waypoint extends React.Component<WaypointProps, any>{
    private _waypointDivRef: HTMLDivElement;
    private _perimeterSearchContextRef: PerimeterSearchContextMenu;
    private _geomapUtil: GeomapUtil;
    private _outerPanelStyle: React.CSSProperties;
    private _innerPanelStyle: React.CSSProperties;
    private _textDivStyle: React.CSSProperties;
    private _centerDivStyle: React.CSSProperties;
    perimeterSearchTranslations: PerimeterSearchContextMenuTranslations;

    constructor(props) {
        super(props);
        this._outerPanelStyle = {
            flex: 2,
            padding: "5px"
        };
        this._innerPanelStyle = {
            boxShadow: "0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0,0,0,.12)",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "0px 14px 0px 14px"
        };
        this._textDivStyle = {
            display: "flex",
            alignItems: "center",
            height: "100%"
        };

        this._geomapUtil = GeomapUtil.getInstance();
        this.perimeterSearchTranslations = { address: this.props.translations["Adresse.Adresse"], machine: this.props.translations["Maschine.Maschine"], resource: this.props.translations["Ressource.Ressource"], assignment: this.props.translations["Einsatz.Einsatz"], ticket: this.props.translations["Vorgang.Ticket"] };
    }

    private _getConfigObject(type: WaypointType) {
        let configObject: WaypointTypeConfig;
        switch (type) {
            case WaypointType.ADDRESS: configObject = { title: this.props.translations["GeoMap.FocusPin"], url: "AddressLookup/AddressHeader", template: "AddressDetails", classes: "geomap__geomap-button", faClasses: "fal fa-crosshairs" }; break;
            case WaypointType.MACHINE: configObject = { title: this.props.translations["GeoMap.FocusPin"], url: "MachineLookup/MachineHeader", template: "MachineDetails", classes: "geomap__geomap-button", faClasses: "fal fa-crosshairs" }; break;
            case WaypointType.RESOURCE: configObject = { title: this.props.translations["GeoMap.FocusPin"], url: "ResourceLookup/ResourceHeader", template: "ResourceDetails", classes: "geomap__geomap-button", faClasses: "fal fa-crosshairs" }; break;
            case WaypointType.ASSIGNMENT: configObject = { title: this.props.translations["GeoMap.FocusPin"], url: "Directions/AssignmentHeader", template: "AssignmentDetails", classes: "geomap__geomap-button", faClasses: "fal fa-crosshairs" }; break;
            case WaypointType.TICKET: configObject = { title: this.props.translations["GeoMap.FocusPin"], url: "ProcedureLookup/ProcedureHeader", template: "ProcedureDetails", classes: "geomap__geomap-button", faClasses: "fal fa-crosshairs" }; break;
            case WaypointType.COORDINATEPIN: configObject = { title: this.props.translations["GeoMap.FocusPin"], classes: "geomap__geomap-button", faClasses: "fal fa-crosshairs" }; break;
        }
        return configObject;
    }

    private _createPanelbarDetailsField = (model: string, url: string, template: string) => {
        let field: IsPanelbarDetailsField = {
            url: url,
            template: template,
            type: "isPanelbarDetails",
            model: model
        };
        return field;
    }

    private _draggableOnDragStart = (e: kendo.ui.DraggableEvent) => {
        $("#geomap__directions").addClass("geomap__dragged-directions-state");
    }

    private _draggableOnDragEnd = (e: kendo.ui.DraggableEvent) => {
        $("#geomap__directions").removeClass("geomap__dragged-directions-state");
        this.props.onDragEnd(e, this.props.idx, this.props.routeID);
    }

    private _getNoGeocodeClass = (wp: WaypointData) => {
        return this._geomapUtil.isWaypointGeocoded(wp) ? "" : "geomap__no-geocoded-waypoint";
    }

    private _isButtonDisplayed = (wp: WaypointData) => {
        return this._geomapUtil.isWaypointGeocoded(wp);
    }

    private _droptargetOnDragEnter = (e: kendo.ui.DropTargetDragenterEvent) => {
        e.dropTarget.addClass("geomap__drag-target");
    }

    private _droptargetOnDragLeave = (e: kendo.ui.DropTargetDragleaveEvent) => {
        e.dropTarget.removeClass("geomap__drag-target");
    }

    private _droptargetOnDrop = (e: kendo.ui.DropTargetDropEvent) => {
        e.dropTarget.removeClass("geomap__drag-target");
        this.props.targetOnDrop(e, this.props.routeID, this.props.idx);
    }

    private _onPerimeterSearchButtonClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        const rect = e.currentTarget.getBoundingClientRect();
        const left = rect.left;
        const top = rect.top;
        this._perimeterSearchContextRef.setVisible(left, top);
    }

    private _getButtons = () => {
        if (!this.props.waypoint.readOnly) {
            return (<>
                <Button handleClick={() => { this.props.removeWaypoint(this.props.waypoint.id, this.props.routeID) }}
                    title={this.props.translations["GeoMap.EntferneWegpunkt"]} iconName={"times"} buttonStyle={{ marginTop: "6px", width: "15px", height: "15px", borderStyle: "none" }} />
                {this._geomapUtil.isWaypointGeocoded(this.props.waypoint) ?
                    <>
                        <Button handleClick={this._onPerimeterSearchButtonClick}
                            title={this.props.translations["GeoMap.PerimeterSearch"]} iconName={"dot-circle"} buttonStyle={{ marginTop: "6px", width: "15px", height: "15px", borderStyle: "none" }} />
                        <PerimeterSearchContextMenu ref={this.setPerimeterSearchContextRef} onEntryClick={this.onPerimeterSearchEntryClick} translations={this.perimeterSearchTranslations}></PerimeterSearchContextMenu>
                    </>
                    : null
                }
            </>
            );
        }
        else {
            return null;
        }
    }

    private _getPanel = (configObject: WaypointTypeConfig) => {
        if (this.props.waypoint.waypointType === WaypointType.COORDINATEPIN) {
            return <div style={this._outerPanelStyle}>
                <div style={this._innerPanelStyle}>
                    <div style={this._textDivStyle}><div className={"truncate"} style={{ padding: "2px 0px 2px 0px" }}>{`Lat: ${this.props.waypoint.lat}`}</div></div>
                    <div style={this._textDivStyle}><div className={"truncate"} style={{ padding: "2px 0px 2px 0px" }}>{` Lng: ${this.props.waypoint.lng}`}</div></div>
                </div>
            </div>;
        }
        return <div style={this._outerPanelStyle}>
            <IsPanelbarDetails field={this._createPanelbarDetailsField("waypoint.no", configObject.url, configObject.template)} commandManager={null} value={this.props.waypoint.entityId} onDataLoaded={() => { }} />
        </div>;
    }

    setPerimeterSearchContextRef = (ref: PerimeterSearchContextMenu) => {
        this._perimeterSearchContextRef = ref;
    }

    onPerimeterSearchEntryClick = (waypointType: WaypointType) => {
        this.props.openPerimeterSearch(this.props.waypoint.lat, this.props.waypoint.lng, this.props.routeID, this.props.waypoint, waypointType);
    }

    markPoint = () => {
        this.props.markPoint(this.props.waypoint.markerId);
    }

    removePointMarking = () => {
        this.props.removePointMarking();
    }

    componentDidMount() {
        if (!this.props.waypoint.readOnly) {
            $(this._waypointDivRef).kendoDraggable({
                hint: (element: any) => {
                    return element.clone().addClass("geomap__dragged-waypoint");
                },
                dragstart: this._draggableOnDragStart,
                dragend: this._draggableOnDragEnd,
                drag: this.props.onDrag
            });

            $(this._waypointDivRef).kendoDropTarget({
                dragenter: this._droptargetOnDragEnter,
                dragleave: this._droptargetOnDragLeave,
                drop: this._droptargetOnDrop
            });
        }

        this._waypointDivRef.addEventListener("mouseenter", this.markPoint);
        this._waypointDivRef.addEventListener("mouseleave", this.removePointMarking);
    }

    componentWillUnmount() {
        this._waypointDivRef.removeEventListener("mouseenter", this.markPoint);
        this._waypointDivRef.removeEventListener("mouseleave", this.removePointMarking);
    }

    render() {
        let configObject = this._getConfigObject(this.props.waypoint.waypointType);
        return (
            <div style={{ display: "flex", flexDirection: "column", padding: "0px 3px 5px 3px" }} ref={(r) => { this._waypointDivRef = r; }} className={this._getNoGeocodeClass(this.props.waypoint)}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div>
                        <div style={{ backgroundColor: "white", marginTop: "10px" }} className={configObject.classes} title={configObject.title} onClick={() => { if (this._isButtonDisplayed(this.props.waypoint)) this.props.setFocusToMarker(this.props.idx, this.props.routeID) }}>
                            <i className={configObject.faClasses}></i>
                        </div>
                    </div>
                    {this._getPanel(configObject)}
                    <div style={{ display: "Flex", flexDirection: "column" }}>
                        {this._getButtons()}
                    </div>
                </div>
            </div>
        );
    }
}


export interface WaypointData {
    id: string;
    markerId?: string;
    waypointType: WaypointType;
    no?: any;
    name?: string;
    address?: string;
    lat: number;
    lng: number;
    description?: string;
    entityId?: any;
    adrnr?: any;
    readOnly?: boolean;
    entity?: Object;
    useTempCoordinates?: boolean;
}

interface WaypointProps extends DirectionsCommonProps {
    waypoint: WaypointData;
    idx: number;
    setFocusToMarker(no: number, routeID: number): void;
    removeWaypoint(id: string, routeID: number): void;
    routeID: number;
    openPerimeterSearch(latitude: number, longitude: number, routeID: number, waypoint: WaypointData, searchType: WaypointType, points?: Array<google.maps.LatLngLiteral>): void;
    onDrag(e: any): void;
    onDragEnd(e: any, no: number, routeID: number): void;
    targetOnDrop(e: any, routeID: number, dropIdx: number): void;
    markPoint(markerID: string): void;
    removePointMarking(): void;
}

interface WaypointTypeConfig {
    title: string;
    classes: string;
    url?: string;
    template?: string;
    faClasses: string;
}

export enum WaypointType {
    ADDRESS, MACHINE, RESOURCE, ASSIGNMENT, TICKET, GEOCODEPIN, COORDINATEPIN
}